import { batch, type Signal, signal } from "@preact/signals";

const LINKS_PROPERTY: unique symbol = Symbol();

export class Progress {
  [LINKS_PROPERTY] = new Map<number, Signal<boolean>>();

  setLinks(links: Record<number, boolean>) {
    batch(() => {
      for (const [id, value] of Object.entries(links)) {
        const link = getLink(this, parseInt(id, 10));
        link.value = value;
      }
    });
  }
}

function getLink(progress: Progress, id: number) {
  let collectedSignal = progress[LINKS_PROPERTY].get(id);
  if (!collectedSignal) {
    collectedSignal = signal(false);
    progress[LINKS_PROPERTY].set(id, collectedSignal);
  }
  return collectedSignal;
}

export function isLinkCollected(progress: Progress, id: number) {
  return getLink(progress, id).value === true;
}
